let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3vYo3")).then(() => parcelRequire('gedwp'));